export const initialState = {
  states: []
}

export default function(state = initialState, action) {
  const { payload, type } = action

  switch(type) {
    case 'SHOP_ORDER_STATES_LOAD_SUCCEEDED':
      let states = {}
      payload.data.forEach(state => states[state.id] = state.name)

      return {
        ...state,
        states: states
      }
    default:
      return state
  }
}
